var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.titleArea,style:({ marginBottom: _vm.marginBottom, marginTop: _vm.marginTop })},[_c('h2',[_vm._v(_vm._s(_vm.subpageTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }